if (!customElements.get('custom-pagination')) {
  customElements.define('custom-pagination', class CustomPagination extends HTMLElement {
    constructor() {
      super();
      this.ELM_items = document.querySelectorAll('[data-pagination-item]');
      this.ELM_sortSelect = document.querySelector('[data-sort-select]');
      this.totalItems = this.ELM_items.length;
      this.ELM_btnNext = this.querySelector('[data-nav-next]');
      this.ELM_btnPrev = this.querySelector('[data-nav-prev]');
      this.ELM_currentPage = this.querySelector('[data-current-page]');
      this.ELM_totalPages = this.querySelector('[data-total-pages]');
      this.perPage = parseInt(this.dataset['perPage']);
      this.current_page = 1;

      this.numPages = Math.ceil(this.totalItems / this.perPage);
      if (this.numPages < 2) {
        this.classList.add('hidden')
      }

      if (this.ELM_items.length) {
        this.changePage(1);
        this.ELM_btnPrev.addEventListener("click", () => this.prevPage());
        this.ELM_btnNext.addEventListener("click", () => this.nextPage());

        if (document.querySelector('[data-count]')) {
          document.querySelector('[data-count]').innerHTML = this.totalItems > 1 ? `${this.totalItems} results` : `${this.totalItems} result`;
        }
        this.buildPaginationList();

        this.ELM_sortSelect?.addEventListener("change", (e) => {
          this.changePage(1);
          this.sort(this.ELM_sortSelect.value)
        });
      }
    }

    sort(param) {
      const divs = [];

      for (var i = 0; i < this.ELM_items.length; ++i) {
        divs.push(this.ELM_items[i]);
      }

      divs.sort((a,b) => {
        const aTitle = a.querySelector('.heading').innerHTML;
        const bTitle = b.querySelector('.heading').innerHTML;
        const aDate = a.getAttribute('data-publish-as');
        const bDate = b.getAttribute('data-publish-as');

        switch (param) {
          case 'title-ascending':
            return aTitle.localeCompare(bTitle);

          case 'title-descending':
            return -aTitle.localeCompare(bTitle);

          case 'created-ascending':
            return aDate.localeCompare(bDate);

          case 'created-descending':
            return -aDate.localeCompare(bDate);

          default:
            break;
        }
      });

      let wholeHtml = "";
      for(let i in divs){
        const d = divs[i];
        if(d.getAttribute){
          const c = d.getAttribute('class');
          const publishAs = d.getAttribute('data-publish-as');
          const innerHtml = d.innerHTML;
          const html = `<div data-pagination-item data-publish-as="${publishAs}" class="${c}">${innerHtml}</div> \n`
          wholeHtml += html;
        }
      }

      document.getElementById('blog-articles').innerHTML = wholeHtml;
    }

    buildPaginationList() {
      let paginationHtml = '';

      for (let index = 0; index < this.numPages; index++) {
        let className = "";
        if (index == 0 ) className = "active";
        paginationHtml += `<div class="pagination__item">
                            <span data-pagination-item-link class="pagination__item__link ${className}">${index + 1}</span>
                          </div>`
      }
      document.getElementById('pagination-list-number').innerHTML = paginationHtml;

      this.ELM_paginationItems = document.querySelectorAll('[data-pagination-item-link]');
      this.ELM_paginationItems.forEach(elm => {
        elm.addEventListener('click', e => {
          const targetPage = e.currentTarget.innerHTML;
          this.changePage(parseInt(targetPage));
          this.scrollToAnchorTop();
        })
      })
    }

    scrollToAnchorTop() {
      const ELM_anchorScrollTop = document.getElementById('anchor-scroll-top');
      let scrollTop = 0;
      if (ELM_anchorScrollTop) {
        scrollTop = ELM_anchorScrollTop.offsetTop;
      }

      window.scrollTo({
        top: scrollTop
      });
    }

    changePage(page) {
      this.ELM_items = document.querySelectorAll('[data-pagination-item]');
      this.totalItems = this.ELM_items.length;

      // Validate page
      if (page < 1) page = 1;
      if (page > this.numPages) page = this.numPages;

      this.hideAllItems();

      for (var i = (page-1) * this.perPage; i < (page * this.perPage) && i < this.totalItems; i++) {
        this.ELM_items[i].classList.remove('hidden');
      }

      this.ELM_currentPage.innerHTML = page;
      this.ELM_totalPages.innerHTML = this.numPages.toString();

      if (page == 1) {
        this.ELM_btnPrev.classList.add('disabled');
      } else {
        this.ELM_btnPrev.classList.remove('disabled');
      }

      if (page == this.numPages) {
        this.ELM_btnNext.classList.add('disabled');
      } else {
        this.ELM_btnNext.classList.remove('disabled');
      }

      if (this.ELM_paginationItems && this.ELM_paginationItems.length) {
        this.ELM_paginationItems.forEach((elm, idx) => {
          this.ELM_paginationItems[idx].classList.remove('active');
        });
        this.ELM_paginationItems[page-1].classList.add('active');
      }
    }

    hideAllItems() {
      this.ELM_items = document.querySelectorAll('[data-pagination-item]');
      this.ELM_items.forEach(item => {
        item.classList.add('hidden');
      });
    }

    prevPage() {
      if (this.current_page > 1) {
        this.current_page--;
        this.changePage(this.current_page);
        this.scrollToAnchorTop();
      }
    }

    nextPage() {
      if (this.current_page < this.numPages) {
        this.current_page++;
        this.changePage(this.current_page);
        this.scrollToAnchorTop();
      }
    }
  });
}
